<template>
  <modal
  name="item-modifiers"
  :width="isMobileDevice ? '90%' : '45%'"
  height=auto
    :adaptive="true"
    draggable=".window-header"
    :class="[
      'rounded-t-xxl vm-modal4 modal-container h-40 overflow-y  flex items-center',
      menu.is_square_layout ? 'deleteModalSquare' : 'roundedmodal',
    ]"
    @before-close="$emit('before-close')"
    @before-open="openingModal"
    @opened="onModalOpened"
    scrollable
  >
        <a
          @click="handleCloseModifierModalMobile"
          class="h-10 w-10 rounded-full flex justify-center items-center absolute right-4 top-4 z-50"
        >
          <IconCancel
            :style="btnDestructiveBackground"
            :stroke="btnDestructiveIcon"
          />
        </a>
        <!-- img -->
        <div v-if="menu.product_images_enabled && selectedMenuCategory.enable_product_images" class="relative h-1/3">
          <!-- <img
            v-if="currentItem.pictureUrl"
            :src="currentItem.pictureUrl"
            alt
            class="object-cover rounded-t-xxl w-full h-56"
          /> -->

          <Picture
            v-if="currentItem.pictureUrl"
            :src="currentItem.pictureUrl"
            alt
            class="object-cover rounded-t-xxl w-full h-56"
          />
        </div>
        <div
          :class="[
            'flex flex-col rounded-xxl h-full',
            currentItem.pictureUrl && menu.product_images_enabled && selectedMenuCategory.enable_product_images
              ? '-mt-10 '
              : '',
          ]"
        >
          <div class="z-20 rounded-xxl h-full" :style="menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground">
            <div
              ref="shadowBottom"
              :class="['py-4 sticky top-0 rouned-t-xxl z-50',
              menuSubCategoriesBackground || mainSubCategorysBackground ? '' : 'bg-white shadow-bottom']"
              :style="menuSubCategoriesBackground || mainSubCategorysBackground ? (menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground ) : ''"
            >
              <div class="w-full flex justify-between">
                <button
              v-if="currentItem.isComboDeal&&comboItemSelectionStep !== 0"
              @click="previousStep"
              class="h-10 w-10 rounded-full flex justify-center items-center absolute left-4 top-4"
              :class="[
                !canGoBack
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :disabled="comboItemSelectionStep == 0 || !canGoBack"
            >

              <IconBackArrow
                class="fill-current inline-block h-8 w-8 p-2 rounded-full cursor-pointer bg-background-red"
                fill="currentColor"
              />
            </button>
                <div
                  :class="[
                    ' font-bold flex-grow text-center flex self-center justify-center text-xl',
                  ]"
                  :style="makeStyles(listsText , hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                >
                  {{ currentItem[`name_${language}`] }}
                </div>
              </div>
              <!-- Progress Bar -->
            <div
              class="flex flex-row h-8 rounded-xl relative justify-center items-center mb-2" v-if="modifiers.length > 1"
            >
            
              <div v-if="modifiers.length > 1">
                  <button
                    v-for="(modifier, index) in modifiers"
                    :key="modifier.AdditionGroupId"
                    class="fill-current font-bold rounded-full focus:outline-none inline-block font-bold rounded-full m-2 w-14 px-2"
                    :style="comboItemSelectionStep == index ? makeStyles(currentModifierIndexBackground): makeStyles(addMoreItemsIconBackground)"
                  >
                  <span 
                    :style="comboItemSelectionStep == index ?` color: ${customThemeVariables['current-modifier-index-color']}` : `color: ${customThemeVariables['kiosk-plus-min-buttons']}`"                  
                    class="text-l md:w-5 h-5 md:h-5 xs:w-4 xs:h-4">
                      {{ index + 1 }}
                  </span>
                  </button>
              </div>
            </div>
            </div>
            <!-- <div
              :class="['text-center text-xs md:text-lg px-10']"
              :style="itemDescription"
            >
              {{ currentItem["description" + "_" + language] }}
            </div> -->

            

            <div class="overflow-y-auto h-full z-20">
              <div
                :class="['px-6 allAdditions overflow-y-auto h-full z-20',
                index == comboItemSelectionStep ? '' : 'hidden']"
                v-for="(modifier, index) in modifiers"
                :key="modifier.AdditionGroupId"
              >
                  <!-- <div v-if="index == currentModifierIndex"> -->
                  <div v-show="index == comboItemSelectionStep">
                      <additions
                        :modifiers="modifiers"
                        :modifier="modifier"
                        :key="index"
                        :allSelectedModifiers="selectedModifiers"
                        :isComboDeal="currentItem.isComboDeal"
                      />
                  </div>
              </div>
            </div>
            <!-- fixed bottom-0 left-0 shadow-outer-box -->
            <div
              :class="[
                'pt-8 flex flex-col justify-center px-6 pb-6 items-center sticky bottom-0 left-0',
                menuSubCategoriesBackground || mainSubCategorysBackground ? '': 'OrderButton__backdrop',
              ]"
              :style="menuSubCategoriesBackground || mainSubCategorysBackground ? (menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground ) : ''"
            >
              <div
              class="flex flex-row h-8 rounded-xl relative justify-center items-center mb-2"
            >
              <button
                @click.stop="deleteNumberOfOrders()"
                class="fill-current rounded-full focus:outline-none inline-block font-bold rounded-full m-2 w-14 p-1"
                :style="makeStyles(addMoreItemsIconBackground)"
              >
                  <IconMinus
                      :stroke="kioskPlusAndMinusButtons"
                      :style="btnOutlineIcon"
                      classes="w-5 md:w-5 h-5 xs:w-4 xs:h-4"
                  />
              </button>
              <input
                type="text"
                readonly
                class="font-bold text-xl focus:outline-none text-center h-6 w-10 text-lg md:text-basecursor-default flex items-center outline-none justify-center bg-transparent"
                name="morePrders"
                :value="numberOfOrder"
                :style="addMoreItemsNumber"
              />
              <button
                @click.stop="addNumberOfOrders()"
                class="font-bold rounded-full cursor-pointer focus:outline-none m-2 w-14 p-1"
                :style="makeStyles(addMoreItemsIconBackground)"

              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="md:w-5 h-5 md:h-5 xs:w-4 xs:h-4">
                  <path
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    fill="none"
                    :stroke="kioskPlusAndMinusButtons"
                    :style="btnOutlineIcon"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
              <!-- add button -->
              <!-- <button
                @click="
                  orderingEnabled &&
                  selectedMenuCategory.is_ordering_disabled == false
                    ? disableAddToCartButton
                      ? checkModifiers()
                      : addToCartWithModifiers()
                    : ''
                "
                :class="[
                  'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 h-8',
                  this.disableAddToCartButton && 'bg-primary-light',
                  orderingEnabled &&
                  selectedMenuCategory.is_ordering_disabled == false
                    ? disableAddToCartButton
                      ? 'opacity-40 cursor-not-allowed'
                      : 'opacity-100'
                    : 'opacity-40 cursor-not-allowed',
                ]"
                :style="paymentBtnBackground + paymentBtnText"
              >
                <div
                  v-if="
                    orderingEnabled &&
                      selectedMenuCategory.is_ordering_disabled == false
                  "
                >
                  <p >{{ lang["add_to_cart"][language] }}</p>

                  <p
                    :class="[
                      'h-full flex items-center positionPrice',
                    ]"
                    v-currency="itemPrice"
                  ></p>
                </div>
                <div v-else>
                  <p>{{ lang["ordering_not_available"][language] }}</p>
                </div>
              </button> -->

              <button
              v-if="
                !currentItem.isComboDeal ||
                (!disableAddToCartButton &&
                  comboItemSelectionStep == modifiers.length - 1)
              "
            @click="
                disableAddToCartButton
                  ? checkModifiers()
                  : addToCartWithModifiers()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md ml-4 py-2',
                this.disableAddToCartButton && 'bg-primary-light',
                disableAddToCartButton
                  ? 'opacity-40 cursor-not-allowed'
                  : 'opacity-100',
              ]"
              :style="makeStyles(paymentBtnBackground , paymentBtnText)"
            >
              <div>

                <p v-if="disableAddToCartButton">
                  {{ lang["add_additions"][language] }}
                </p>
                <p v-else-if="isMobileDevice">
                  {{ lang["add_to_cart"][language] }}
                </p>
                <p v-else>{{ lang["add_to_order"][language] }}</p>
                <p
                  class="positionPrice py-2 flex items-center"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
            <button
              v-else
              @click="
                !enableNextStep ||
                comboItemSelectionStep == modifiers.length - 1
                  ? checkModifiers()
                  : nextStep()
              "
              :class="[
                'w-full rounded-full relative bg-new-primary rounded px-2 text-md py-2',
                !enableNextStep ||
                comboItemSelectionStep >= modifiers.length - 1
                  ? 'opacity-40 cursor-not-allowed bg-primary-light'
                  : 'opacity-100',
              ]"
              :style="paymentBtnBackground + paymentBtnText"
            >
              <div>
                <p
                  v-if="
                    !enableNextStep ||
                    comboItemSelectionStep == modifiers.length - 1
                  "
                >
                  {{ lang["add_additions"][language] }}
                </p>
                <p v-else>{{ lang["next"][language] }}</p>
                <p
                  class="positionPrice py-2 flex items-center"
                  v-currency="itemPrice"
                ></p>
              </div>
            </button>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </modal>
</template>

<script>
import Additions from "../components/Additions";
import { mapGetters } from 'vuex';
import lang from "../lang";
import IconCancel from "./icons/iconCancel.vue";
import IconBackArrow from "./icons/iconBackArrow.vue";
import IconMinus from "./icons/iconMinus.vue";
export default {
    components:{
    Additions,
    IconCancel,
    IconMinus,
    IconBackArrow
},
    props:{
        currentItem:{
            type:Object,
            require:true,
        },
        selectedModifiers:{
            type:Array,
            require:true,
        },
        disableAddToCartButton:{
            type:Boolean,
            require:true,
        },
        modifiers:{
            type:Array,
            require:true,
        },
        addToCartWithModifiers:{
            type:Function,
            require:true,
        },
        checkModifiers:{
            type:Function,
            require:true,
        },
        itemDescription:{
            type:String,
            require:true,
        },
         enableNextStep:{
            type:Boolean,
            require:true,
        },
        canGoBack:{
            type:Boolean,
            require:true,
        },
    },
data() {
    return {
      lang: lang,
      numberOfOrder: 1,
      comboItemSteps: [],
    }
},
computed:{
    ...mapGetters([
        'menu',
        'hasKiosk',
        "orderingEnabled",
        "selectedMenuCategory",
        "itemPrice",
        "language",
        "comboItemSelectionStep",
        "isMobileDevice",
        ]),
    ...mapGetters("Theme", [
        "titleFont",
        "titleTextTransform",
        "listsText",
        "mainSectionTopRadius",
        "paymentBtnText",
        "btnDestructiveIcon",
        "paymentBtnBackground",
        "btnDestructiveBackground",
        "mainSubCategorysBackground",
        "addButtonRadius",
        "addMoreItemsIconBackground",
        "kioskPlusAndMinusButtons",
        "btnOutlineIcon",
        "addMoreItemsNumber",
        "customThemeVariables",
        "currentModifierIndexBackground",
        "backgroundImage",
        "menuSubCategoriesBackground",
]),
    },
    
// Select the first addition item in the combo deal if there's single item in the addition
watch: {
    modifiers(newValue, oldValue) {
      if (newValue !== oldValue) {
        for (let i = 1; i < this.modifiers.length; i++) {
          this.comboItemSteps.push(i);
      }
      setTimeout(() => {
        if (this.modifiers[0].Additions.length == 1) {
              let additionId = this.modifiers[0].Additions[0].Id
            document.getElementById(additionId).click()
        }
      }, 200);       
      }
    },

    comboItemSelectionStep(value) {
       if (this.modifiers[value].Additions.length == 1 && this.comboItemSteps.includes(value)) {
         let additionId = this.modifiers[value].Additions[0].Id
         document.getElementById(additionId).click()
         this.comboItemSteps = this.comboItemSteps.filter(el => {
           return el != value
         });
      }
    }
  },
methods: {
  onModalOpened() {
    if (this.mainSubCategorysBackground.includes('#FFFFFF') && (this.menuSubCategoriesBackground ? this.menuSubCategoriesBackground.includes('#FFFFFF') : true)) {
      const divElement = this.$refs.shadowBottom;
    divElement.classList.add('shadow-bottom');
    }
    },
  addNumberOfOrders() {
      this.$store.commit("Cart/updateOrderItemCount", ++this.numberOfOrder);
  },
    
  deleteNumberOfOrders() {
    if (this.numberOfOrder > 1) {
        this.$store.commit("Cart/updateOrderItemCount", --this.numberOfOrder);
      }  
    },
  handleCloseModifierModalMobile() {
    this.$modal.hide('item-modifiers');
  },
  openingModal() {
    this.numberOfOrder = 1;
    this.$emit('open-modifier');
    },
    nextStep() {
        this.$store.commit("comboItemSelectionStepIncrement");
    },
    previousStep() {
      this.$store.commit("comboItemSelectionStepDecrement");

  },
}
}
</script>

<style scoped>

.positionPrice {
  position: absolute;
  top: 0;
  right: 25px;
}
.shadow-bottom {
  webkit-box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
  -moz-box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
  box-shadow: 0px 10px 25px 0px rgba(255,255,255,0.75);
}
.OrderButton__backdrop {
  /* background: linear-gradient(0deg, white, transparent); */
  background: white;
}
.vm--modal {
  height: 90vh !important;
}

</style>